import { fetchAdditions } from '#action/fetch';
import {
  FETCH_META_DEVICE
} from '#action/types';

export const fetchMeta = () =>
  dispatch =>
    dispatch(fetchAdditions('meta/device', FETCH_META_DEVICE));
